module.exports = __webpack_public_path__ + "media/images/brands/logo_faktor-86f9ae2c48cf86af0514f9730577468a.svg";